module.exports = __webpack_public_path__ + "static/media/stm-delete.9a2dfdff.svg";